module.exports = JSON.parse('{"Copied":"Copied","Failed to copy":"Failed to copy"}')